<div class="h-100" style="display: flex; flex-direction: column">
  <div class="flex-row-space-between">
    <h1>Modul Typen</h1>
    <core-button-icon-big
      *ngIf="userCanEdit"
      (click)="onCreate()"
      [type]="InputButtonIconType.ADD">
    </core-button-icon-big>
  </div>

  <div class="h-100">
    <p-table [value]="moduleTypes" [loading]="loading" [autoLayout]="true">
      <ng-template pTemplate="header">
        <tr>
          <th>Name</th>
          <th>Code</th>
          <th style="width: 100px"></th>
        </tr>
      </ng-template>
      <ng-template let-item pTemplate="body">
        <tr>
          <td>{{item.name}}</td>
          <td>{{item.code}}</td>
          <td class="file-table-column-action-buttons">
            <core-button-icon
              (click)="onEdit(item)"
              [type]="userCanEdit ? InputButtonIconType.EDIT : InputButtonIconType.READ">
            </core-button-icon>
            <core-button-icon
              *ngIf="userCanEdit"
              (click)="onDelete(item)"
              [type]="InputButtonIconType.DELETE">
            </core-button-icon>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>
